import {
  formatMoney,
  REGISTERED_TIER,
  type RegisteredTier,
} from "@roof-hawk/core";

import { t } from "../../i18n";

/** The two small pieces of the Register Warranty form (ADR 0309). */

export function TierOption({ tier, of }: { tier: RegisteredTier; of: number }) {
  const facts = REGISTERED_TIER[tier];
  const rate = facts.perSquare ? `, ${formatMoney(facts.perSquare)}/sq` : "";
  return (
    <option value={tier}>
      {t("{name} ({n} of {of} parts{rate})", {
        name: facts.name,
        n: facts.accessories,
        of,
        rate,
      })}
    </option>
  );
}

export function TextField({
  id,
  label,
  value,
  onChange,
  decimal,
  date,
}: {
  id: string;
  label: string;
  value: string;
  onChange: (value: string) => void;
  decimal?: boolean;
  date?: boolean;
}) {
  return (
    <div className="field">
      <label htmlFor={id}>{label}</label>
      <input
        id={id}
        type={date ? "date" : "text"}
        inputMode={decimal ? "decimal" : undefined}
        value={value}
        onChange={(e) => onChange(e.target.value)}
      />
    </div>
  );
}
